export const BLACKLIST_MANAGE_MODAL_STAGES = {
  close: 'close',
  manage: 'manage',
  manageConfirmation: 'manageConfirmation',
};
